var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',{staticClass:"upload-tab",attrs:{"flat":""}},[_c('q-card-section',{staticClass:"bg-white fit cards-grid"},[_c('DoiCard',{attrs:{"type":"member"}}),_c('DoiCard',{attrs:{"type":"publisher"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }